import { CopyIcon, MapPinIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";
import { IconButton } from "@/components/IconButton/IconButton";
import { HotelMap } from "@/features/hotels/components/hotel/HotelMapLazy";
import type { HotelData } from "@/features/hotels/types/types";
import { copyToClipboardWithFeedback } from "@/utils/copyToClipboard";

interface HotelLocationCardProps {
  hotel: HotelData;
}

export const HotelLocationCard = ({ hotel }: HotelLocationCardProps) => {
  const intl = useIntl();

  if (!hotel.geolocation && !hotel.address) return null;

  return (
    <CollapsibleCard
      title={intl.formatMessage({
        defaultMessage: "Location",
        description: "Hotel's location card title",
      })}
      collapsible={false}
    >
      <HotelMap hotel={hotel} />

      {hotel.address && (
        <div className="mt-4 flex items-center gap-1">
          <MapPinIcon size={16} className="shrink-0 text-text-primary" />
          <p className="text-sm text-text-primary">{hotel.address}</p>
          <IconButton
            color="interactive"
            size="small"
            onClick={() =>
              copyToClipboardWithFeedback(
                hotel.address,
                intl.formatMessage({
                  defaultMessage: "Hotel address copied",
                  description: "Snackbar shown after copying the hotel address",
                }),
              )
            }
            aria-label={intl.formatMessage({
              defaultMessage: "Copy address",
              description: "Button to copy the hotel address to clipboard",
            })}
          >
            <CopyIcon size={16} />
          </IconButton>
        </div>
      )}
    </CollapsibleCard>
  );
};
